import {FormControl} from '@angular/forms';

export function required(c: FormControl) {
    return (!!c.value || typeof c.value == 'boolean') ? null : {
        message: 'lta-errors.required'
    };
}

export function createDependentRequiredValidator<T>(valueField: string, reqField: string, valueCheck: (v: T) => boolean) {
    return function (c: FormControl) {
        if (valueCheck(c.get(valueField).value)) {
            c.get(reqField).setErrors(!!c.get(reqField).value ? null : {
                message: 'lta-errors.required'
            })
            return null
        } else {
            return null
        }
    }
}
